/* eslint-disable */
/* eslint-disable prefer-template */
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortAmountDown, faSortAmountUp } from '@fortawesome/free-solid-svg-icons';
import { HBox } from '../../../components/Box';
import { resetVehicleFilter, applyVehicleFilters } from '../actions';
import { selectMMT, selectVehicleFilter } from '../selectors';
import ReactGA from "react-ga4";

import { SearchLocationCompanyId } from './SearchLocationCompanyId';
import { VehicleSearchText } from './SearchText/SearchText';
import { VehicleFilter } from './VehicleFilter';
import { VehicleSortSelector } from './VehicleSortSelector';
import {
  VEHICLE_BODY_TYPES,
  VEHICLE_BRANDS,
  VEHICLE_COLORS,
  VEHICLE_FUEL_TYPES,
  VEHICLE_TRANSMISSION_TYPES,
  BUYERS_OPTIONS,
} from '../constants';
import _ from 'lodash';
import { FiltersCloud } from './VehicleFiltersCloud';
import { VehicleCreateModals } from '../pages/create/AddVehicleModals';
import { COLOR_BG_LIGHT } from '../../../vars';
import { Permission } from '../../../components/Permission';
import { VEHICLE_CREATE } from '../../../components/Permission/constants';
import env from '../../../env';
import { USER_FILTER_LIST } from '../../../containers/App/constants';
import { AppClientId } from '../../Shared/constants';
import cn from 'classnames';

import ButtonComponent from '../../../containers/App/Components/Button/Button';
import styles from './Search.module.css';

const Container = styled.div`
  & * .Dropdown-root {
    width: 100%;
  }

  .filters-rows {
    gap: 12px;
    padding: 0px 24px 24px 24px;
    background-color: white;
    @media (max-width: 768px) {
      max-width: 100%;
      padding: 15px;
    }
  }

  .form-controlField {
    margin-bottom: 0;
  }

  .button {
    width: auto;
  }

  .fw-light {
    font-size: 12px !important;
    font-weight: 400 !important;
    font-family: Poppins, sans-serif !important;
    padding-left: 10px !important;
    color: #808080 !important;
  }
  @media (max-width: 767.98px) {
    .fw-light {
      font-size: 16px !important;
    }
  }

  .button-filter-right {
    margin-top: -10px;
    margin-right: 10px;
  }

  .all-filters-block {
    padding: 10px;
    background-color: ${COLOR_BG_LIGHT};
  }

  .button-filter {
    padding-right: ${props => props.width > 500 && '24px'};
    & * .button {
      margin: 0px;
      margin-left: 12px;
      background-color: white;
      color: #808c9c;
      border-radius: 8px 8px 0px 0px;
      box-shadow: 0 -2px 6px -1px #ececef;
      &:hover {
        background-color: #0183d5;
        color: #fff;
        box-shadow: none;
      }
    }
  }

  .red-text {
    backgrond-color: red;
  }

  .row-1 {
    & * .decorated {
      width: 100%;
    }
  }

  .grid-column {
  }

  .grid-row-long {
    flex-basis: ${props => (props.width <= 1520 ? '100%' : '49%')};
  }
  .grid-row-short {
    border: 1px solid #cccccc;
    border-radius: 3px;
    flex-basis: 49%;
    & > .button {
      margin: 0px;
    }
  }

  .tablet-row {
    margin-bottom: 22px;
  }

  .row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .button-block {
    & * .button {
      margin: 0px;
    }
  }
  .input-element {
    font-size: 13px;
    height: 45px;
  }
`;

const ShowAllButton = styled.span`
  color: grey !important;
  font-size: 14px;
  color: #0083d5;
  cursor: pointer;
`;

const STATE = {
  showAllFilters: false,
  filterToReset: null,
  isFilterMenuOpen: false,
};

const statusWebloginHOOI = [
  'Credited',
  'Uitgeslagen',
  'Te verwachten',
  'Ingeslagen',
  'Verkocht-uitgeslagen',
  'Verkocht-ingeslagen',
  'Deleted',
];

/* eslint-disable react/prefer-stateless-function */
class VehicleSearchComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  applyFiltersWithTracking = () => {
    const { filter } = this.props;
  
    const searchTerm = filter?.searchString || "";
  
    // Alle actieve filters verzamelen
    const activeFilters = (filter?.properties || [])
      .filter(p => p.value && p.value.length !== 0)
      .map(p => ({ key: p.key, value: p.value }));
  
    // Event naar GA4
    ReactGA.event("vehicle_search", {
      search_term: searchTerm,
      filters: JSON.stringify(activeFilters),
      filters_count: activeFilters.length,
      trigger: "apply_button"
    });
  
    console.log("Filters applied with tracking:", { searchTerm, activeFilters });
  
    // ✅ Gebruik Redux action, niet filterVehicles
    this.props.applyFilters();
  };

  componentDidMount() {}

  get statuses() {
    let statusesQuantity = env.clientId === AppClientId.HILTERMANN || env.clientId === AppClientId.HOOIKAMMER ? 10 : 7;

    let statuses = _.times(statusesQuantity, n => {
      if (n == 1 && env.clientId == AppClientId.HOOIKAMMER) {
        return this.lblStr(`vehicle.property.hooikammer_status.1`);
      }
      if (n == 1 && env.clientId == AppClientId.AUTOHUISSALLAND) {
        return this.lblStr(`vehicle.property.hooikammer_status.1`);
      }

      if (env.clientId === AppClientId.HILTERMANN) {
        if (n >= 6) {
          return this.lblStr(`vehicle.property.status.extra.${n}`);
        }
        return null; // Skip statuses below 7 for HILTERMANN
      }

      return this.lblStr(`vehicle.property.status.${n}`);
    })
      .filter(s => s !== null) // Remove null values
      .map(s => `${s}`);

    return statuses;
  }

  toggleFiltersView = () => {
    this.setState(state => ({ showAllFilters: !state.showAllFilters }));
  };

  resetFilter = name => {
    this.setState({ filterToReset: name });
  };

  toggleFilterMenu = () => {
    this.setState(state => ({
      isFilterMenuOpen: !state.isFilterMenuOpen,
      showAllFilters: state.showAllFilters ? false : state.showAllFilters,
    }));
  };
  handleResetClick = () => {
    this.props.reset();
    this.props.filterVehicles({
      ...this.props.filter,
      properties: [],
      searchString: '',
    });
  };

  render() {
    if (!this.props.filter) return null;

    const STATUSES = this.props.weblogin && env.clientId == AppClientId.HOOIKAMMER ? statusWebloginHOOI : this.statuses;
    const BASE_COLOR_OPTIONS = VEHICLE_COLORS.map(color => {
      const lbl = `vehicle.filter.${color.toLowerCase()}`;
      return { value: color, label: `${this.lblStr(lbl)}` };
    });
    const FUEL_TYPE_OPTIONS = VEHICLE_FUEL_TYPES.map(fuel => {
      let lbl = `vehicle.filter.${fuel.toLowerCase()}`;
      if (fuel == 'hybride benzine') {
        lbl = `vehicle.filter.hybride`;
        return { value: fuel, label: `${this.lblStr(lbl)}` };
      }
      return { value: fuel, label: `${this.lblStr(lbl)}` };
    });
    const VEHICLE_PURPOSE_OPTIONS = ['passenger', 'commercial'].map(p => {
      const lbl = `vehicle.filter.${p.toLowerCase()}`;
      return { value: p, label: `${this.lblStr(lbl)}` };
    });
    const WS2_INSPECTED_OPTIONS = [
      { label: `${this.lblStr('vehicle.filter.inspected')}`, value: '1' },
      { label: `${this.lblStr('vehicle.filter.not_inspected')}`, value: null },
    ];

    const NEW_USED_OPTIONS = [
      { label: `${this.lblStr('vehicle.filter.new')}`, value: '1' },
      { label: `${this.lblStr('vehicle.filter.used')}`, value: '0' },
    ];
    const HAS_REGPLATE_OPTIONS = [
      { label: `${this.lblStr('vehicle.filter.yes')}`, value: '*' },
      { label: `${this.lblStr('vehicle.filter.no')}`, value: '-' },
    ];
    const HAS_TASK_LABELS = [
      { label: `${this.lblStr('vehicle.filter.yes')}`, value: '*' },
      { label: `${this.lblStr('vehicle.filter.no')}`, value: '-' },
    ];

    const B2B_PRICE_FILLED_IN = [
      { label: `${this.lblStr('vehicle.filter.yes')}`, value: '*' },
      { label: `${this.lblStr('vehicle.filter.no')}`, value: '-' },
    ];

    const brandOptions = this.props.mmt?.brands?.map(b => b?.name);
    let selectedBrands = this.props.filter?.properties?.find(p => p.key == 'brand_name')?.value ?? [];
    let selectedBrandIds = this.props.mmt?.brands
      ?.filter(b => selectedBrands?.includes(b?.name?.toLowerCase()))
      ?.map(b => b?.id);

    let modelOptions = [];
    modelOptions = this.props.mmt?.models?.filter(m => selectedBrandIds?.includes(m?.brand_id))?.map(m => m?.name);

    const { isFilterMenuOpen } = this.state;

    if (this.props.weblogin) {
      const brandOptions = this.props.mmt?.brands?.map(b => b?.name);
      let modelOptions = [];
      modelOptions = this.props.mmt?.models?.filter(m => selectedBrandIds?.includes(m?.brand_id))?.map(m => m?.name);
      return (
        <>
          <div className="container-fluid ps-0 pe-0 pt-2 pb-0 bg-white">
            <div className="row p-0 m-0 align-items-center">
              <div className="col-12 mb-3 col-lg-6 mb-3 col-xl-6 col-xxl-3 mb-3">
                <VehicleSearchText
                  filter={this.props.filter}
                  weblogin={this.props.weblogin}
                  filterVehicles={this.props.filterVehicles}
                />
              </div>
              <div className="col-12 mb-3 col-lg-6 mb-3 col-xl-6 col-xxl-3 mb-3">
                <VehicleFilter
                  name="brand_name"
                  type="multiple"
                  options={brandOptions}
                  search
                  isReset={this.state.filterToReset === 'brand_name'}
                />
              </div>
              <div className="col-12 mb-3 col-lg-6 mb-3 col-xl-6 col-xxl-3 mb-3">
                <VehicleFilter name="model_name" nestedFilter type="multiple" options={modelOptions} search />
              </div>

              <div className="col-12 mb-3 col-lg-6 mb-3 col-xl-6 col-xxl-3 mb-3">
                <VehicleFilter name="status" type="multiple" options={STATUSES} />
              </div>
            </div>
          </div>
          <div className="row p-0 mt-2">
            <div className="col-12 mb-3">
              <FiltersCloud weblogin={this.props.weblogin} />
            </div>
            <div className="col-12 mb-3 d-flex gap-2">
              {/* <ButtonComponent style={'ButtonSoftDelete'} onClick={this.handleResetClick}>
                {this.lblStr('invoice.filter.clearAll')}
              </ButtonComponent> */}
              <ButtonComponent 
  style={'ButtonSoftEdit'} 
  onClick={this.applyFiltersWithTracking}
>
  {this.lblStr('vehicle.filter.apply')}
</ButtonComponent>
            </div>
          </div>
        </>
      );
    }

    return (
      <Container>
        <div className="container-fluid p-0">
          <HBox className="button-filter-container">
            <div className="button-filter-left">
              <VehicleFilter
                name="status"
                type="multiple"
                buttonFilter
                options={STATUSES}
                apply={this.props.applyFilters.bind(this)}
              />
            </div>
            <div className="button-filter-right">
              <Permission permission={VEHICLE_CREATE}>
                <VehicleCreateModals />
              </Permission>
            </div>
          </HBox>

          <div className="container-fluid ps-0 pe-0 pt-3 pb-0 bg-white">
            <div className="row p-0 m-0 align-items-center">
              {window.innerWidth >= 768 && (
                <div className="col-7 col-sm-8 mb-3 col-md-12 col-lg-12 col-xl-12 col-xxl-6">
                  <VehicleSearchText filter={this.props.filter} />
                </div>
              )}

              {window.innerWidth <= 768 && (
                <>
                  <VehicleSearchText filter={this.props.filter} />

                  <ButtonComponent 
  style={'ButtonSoftEdit'} 
  onClick={this.applyFiltersWithTracking}
>
  {this.lblStr('vehicle.filter.apply')}
</ButtonComponent>

                  <div
                    className={cn('col-5 mb-3 col-sm-2 col-md-3 col-lg-2 col-xl-2 p-0 text-end', styles.buttonContainer)}
                  ></div>
                  <div className={cn('col-12 mb-3 col-sm-2 p-0 text-end', styles.buttonFilterContainer)}>
                    <ButtonComponent style={'ButtonSoftEdit'} onClick={this.toggleFilterMenu}>
                      {this.lbl('vehicle.overview.filter')}
                      {this.state.isFilterMenuOpen ? (
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      ) : (
                        <FontAwesomeIcon icon={faSortAmountDown} />
                      )}
                    </ButtonComponent>
                  </div>
                </>
              )}

              {(window.innerWidth > 768 || isFilterMenuOpen) && (
                <>
                  <div className="col-12 mb-3 col-sm-12 mb-3 col-lg-6 mb-3 col-xl-6 mb-3 col-xxl-3 mb-3">
                    <div className="d-flex gap-2">
                      <div className="w-100">
                        <VehicleFilter name="status" type="multiple" options={STATUSES} />
                      </div>

                      <div className="flex-shrink-0">
                        <SearchLocationCompanyId filter={this.props.filter} />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 mb-3 col-sm-12 mb-3 col-lg-6 mb-3 col-xl-6 mb-3 col-xxl-3 mb-3">
                    <div className="d-flex gap-2">
                      <div className="w-100">
                        <VehicleSortSelector />
                      </div>
                      {window.innerWidth > 768 && (
                        <div className="flex-shrink-0">
                          <Permission permission={VEHICLE_CREATE}>{/* <VehicleCreateModals /> */}</Permission>
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>

          {(window.innerWidth > 768 || isFilterMenuOpen) && (
            <div style={{ backgroundColor: 'white' }} className="container-fluid pt-0">
              <div className="row" style={{ width: 'auto' }}>
                <div className="col-12 mb-3 col-lg-6 mb-3 col-xl-6 col-xxl-3 mb-3">
                  <VehicleFilter
                    name="brand_name"
                    type="multiple"
                    options={brandOptions}
                    search
                    isReset={this.state.filterToReset === 'brand_name'}
                  />
                </div>
                <div className="col-12 mb-3 col-lg-6 mb-3 col-xl-6 col-xxl-3 mb-3">
                  <VehicleFilter
                    name="model_name"
                    //nestedFilter
                    style={{ fontSize: '10px!important' }}
                    type="multiple"
                    options={modelOptions}
                    search
                  />
                </div>
                <div className="col-12 mb-3 col-lg-6 mb-3 col-xl-6 col-xxl-3 mb-3">
                  <VehicleFilter name="date_first_allowance" type="ranged_date" />
                </div>
                <div className="col-12 mb-3 col-lg-6 mb-3 col-xl-6 col-xxl-3 mb-3">
                  <VehicleFilter name="financial_price_b2b_incl_vat_btpm" type="ranged" />
                </div>
                <div className="col-12 mb-3 col-lg-6 mb-3 col-xl-6 col-xxl-3 mb-3">
                  <VehicleFilter name="mileage" type="ranged" />
                </div>
                <div className="col-12 mb-3 col-lg-6 mb-3 col-xl-6 col-xxl-3 mb-3">
                  <VehicleFilter name="tax_type" type="single" options={['btw', 'marge']} />
                </div>

                <div className="col-12 mb-3 col-lg-6 mb-3 col-xl-6 col-xxl-3 mb-3">
                  <VehicleFilter name="financial_price_gross_incl_btw_bpm" type="ranged" />
                </div>

                <div className="col-12 mb-3  col-lg-6 mb-3 col-xl-6 col-xxl-3 mb-3">
                  <VehicleFilter name="financial_price_nett_excl_vat_bpm" type="ranged" />
                </div>

                <div className={cn('col-12 mb-3 col-sm-12 mb-3 col-lg-5 mb-3 col-xl-6 mb-3 text-end', styles.container)}>
                  <FiltersCloud />
                  <div className={styles.buttonShowAll}>
                    <ButtonComponent style={'ButtonSoftLight'} onClick={this.toggleFiltersView}>
                      {this.state.showAllFilters ? this.lbl('vehicle.filter.hideAll') : this.lbl('vehicle.filter.showAll')}
                    </ButtonComponent>
                    {/* <ButtonComponent style={'ButtonSoftDelete'} onClick={this.props.reset}>
                      {this.lblStr('invoice.filter.clearAll')}
                    </ButtonComponent> */}
                     <ButtonComponent 
  style={'ButtonSoftEdit'} 
  onClick={this.applyFiltersWithTracking}
>
  {this.lblStr('vehicle.filter.apply')}
</ButtonComponent>
                  </div>
                </div>
              </div>
            </div>
          )}

          {this.state.showAllFilters && (
            <div style={{ backgroundColor: 'white' }} className="container-fluid pt-2">
              <div className="row justify-content-start" style={{ width: 'auto' }}>
                <div className="col-12 mb-3 col-sm-6 col-md-12 mb-3 col-lg-6 mb-3 col-xl-6 mb-3">
                  <VehicleFilter name="creditor_company" type="single" search="company" className="red-text" />
                </div>

                <div className="col-12 mb-3 col-sm-6 col-md-12 mb-3 col-lg-6 mb-3 col-xl-6 mb-3">
                  <VehicleFilter name="invoice_outgoing_company_id" type="single" search="company" />
                </div>

                <div className="col-12 mb-3 col-sm-6 col-md-12 mb-3 col-lg-6 mb-3 col-xl-6 mb-3">
                  <VehicleFilter name="new_from_factory" type="single" options={NEW_USED_OPTIONS} noModify />
                </div>

                <div className="col-12 mb-3 col-sm-6 col-md-12 mb-3 col-lg-6 mb-3 col-xl-6 mb-3">
                  <VehicleFilter name="vehicle_purpose" type="single" options={['passenger', 'commercial']} />
                </div>

                <div className="col-12 mb-3 col-sm-6 col-md-12 mb-3 col-lg-6 mb-3 col-xl-6 mb-3">
                  <VehicleFilter name="import" type="single" isBool />
                </div>

                <div className="col-12 mb-3 col-sm-6 col-md-12 mb-3 col-lg-6 mb-3 col-xl-6 mb-3">
                  <VehicleFilter name="regplate" type="single" options={HAS_REGPLATE_OPTIONS} noModify />
                </div>

                <div className="col-12 mb-3 col-sm-6 col-md-12 mb-3 col-lg-6 mb-3 col-xl-6 mb-3">
                  <VehicleFilter name="task_label" type="single" options={HAS_TASK_LABELS} noModify />
                </div>

                <div className="col-12 mb-3 col-sm-6 col-md-12 mb-3 col-lg-6 mb-3 col-xl-6 mb-3">
                  <VehicleFilter name="transmission_type" type="single" options={VEHICLE_TRANSMISSION_TYPES} />
                </div>

                <div className="col-12 mb-3 col-sm-6 col-md-12 mb-3 col-lg-6 mb-3 col-xl-6 mb-3">
                  <VehicleFilter name="fuel_type" type="multiple" options={FUEL_TYPE_OPTIONS} noModify />
                </div>

                <div className="col-12 mb-3 col-sm-6 col-md-12 mb-3 col-lg-6 mb-3 col-xl-6 mb-3">
                  <VehicleFilter name="user_buyer_id" type="single" options={BUYERS_OPTIONS} noModify />
                </div>

                <div className="col-12 mb-3 col-sm-6 col-md-12 mb-3 col-lg-6 mb-3 col-xl-6 mb-3">
                  <VehicleFilter name="user_seller_id" type="single" options={BUYERS_OPTIONS} noModify />
                </div>

                <div className="col-12 mb-3 col-sm-6 col-md-12 mb-3 col-lg-6 mb-3 col-xl-6 mb-3">
                  <VehicleFilter name="body_type" type="single" options={VEHICLE_BODY_TYPES} />
                </div>

                <div className="col-12 mb-3 col-sm-6 col-md-12 mb-3 col-lg-6 mb-3 col-xl-6 mb-3">
                  <VehicleFilter name="base_color" type="multiple" options={BASE_COLOR_OPTIONS} noModify />
                </div>

                <div className="col-12 mb-3 col-sm-6 col-md-12 mb-3 col-lg-6 mb-3 col-xl-6 mb-3">
                  <VehicleFilter name="fix_damages" type="single" isBool altKey="dont_fix_damages" />
                </div>

                <div className="col-12 mb-3 col-sm-6 col-md-12 mb-3 col-lg-6 mb-3 col-xl-6 mb-3">
                  <VehicleFilter name="sell_with_license_plate" type="single" isBool altKey="sell_without_license_plate" />
                </div>

                <div className="col-12 mb-3 col-sm-6 col-md-12 mb-3 col-lg-6 mb-3 col-xl-6 mb-3">
                  <VehicleFilter
                    name="action_ws2_interior_inspection_done"
                    type="single"
                    options={WS2_INSPECTED_OPTIONS}
                    noModify
                  />
                </div>
                <div className="col-12 mb-3 col-sm-6 col-md-12 mb-3 col-lg-6 mb-3 col-xl-6 mb-3">
                  <VehicleFilter
                    name="financial_price_b2b_incl_vat_btpm"
                    type="single"
                    options={B2B_PRICE_FILLED_IN}
                    noModify
                  />
                </div>

                <div className="col-12 mb-3 col-sm-6 col-md-12 mb-3 col-lg-6 mb-3 col-xl-6 col-xxl-6 mb-3">
                  <VehicleFilter name="power" type="ranged" />
                </div>
              </div>
            </div>
          )}

          {(this.props.filter.properties.length !== 0 || window.innerWidth > 768 || isFilterMenuOpen) && (
            <div className="row p-0 mt-2">
              {(window.innerWidth > 768 || isFilterMenuOpen) && (
                <>
                  <div className="col-12 mb-3">{/* <FiltersCloud /> */}</div>
                </>
              )}
            </div>
          )}
        </div>
      </Container>
    );
  }
}

VehicleSearchComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    filter: selectVehicleFilter(),
    mmt: selectMMT(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    reset() {
      dispatch(resetVehicleFilter());
    },
    applyFilters() {
      dispatch(applyVehicleFilters());
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleSearch = compose(withConnect, withRouter, injectIntl)(VehicleSearchComp);
